import { authHeader } from '../_helpers';
import httpClient from '../utils/http'
import moment from 'moment';
import _ from 'lodash';
import { handleResponseAsync } from '../utils/HelperUtils';

export const departmentService = {
  getAllDepartments
};

function convertViewModelList(data) {
  let viewModel = [];
  // const defaultOption = {
  //   id: 'all',
  //   value: 'all',
  //   label: '-- All Departments --'
  // };
  // viewModel.push(defaultOption);
  if (!_.isEmpty(data) && _.isArray(data)) {
    data.map(o => {
      o.id = o._id;
      o.value = o.DepartmentId;
      o.label = o.DepartmentName;

      delete o._id;
      delete o.DepartmentId;
      delete o.DepartmentName;

      viewModel.push(o);
    });
  }
  return viewModel;
}

function getAllDepartments() {
  const url = '/api/departments';

  return httpClient
    .get(url)
    .then(handleResponseAsync)
    .then(res => convertViewModelList(res.data));
}
